import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const animateVerticals = {
    $triggerTab: $('.js-vertical-tabs-title'),
    $triggerAccordion: $('.js-vertical-accordion-title'),
    isMobile: $(window).width() < 1025 ? true : false,

    init: function () {
        let $this = this
        this.$triggerTab.on('click', function () {
            let _this = $(this)
            let target = _this.attr('id').split('tab_').pop()

            //First remove .is-active for all tabs and accordions
            $this.$triggerTab.removeClass('is-active')
            $('.js-vertical-accordion-item').removeClass('is-active')

            //Add .is-active for the clicked tab title
            _this.addClass('is-active')

            //Add .is-active only for the content related to this tab title
            $(`#accordion_${target}`).addClass('is-active')

            //Refresh all fading effects
            ScrollTrigger.refresh()
        })
        this.$triggerAccordion.on('click', function () {
            let _this = $(this)
            let target = _this
                .closest('.js-vertical-accordion-item')
                .attr('id')
                .split('accordion_')
                .pop()

            let targetContent = $(`#accordion_${target}`).find(
                '.js-vertical-accordion-content'
            )

            // SlideToggle content related to clicked accordion title
            targetContent.slideToggle(function () {
                if (targetContent.is(':hidden')) {
                    // If content becomes hidden after toggle, remove .is-active for the related accordion title
                    $(`#accordion_${target}`).removeClass('is-active')
                } else if (targetContent.is(':visible')) {
                    // If content becomes visible after toggle, add .is-active for the related accordion title
                    $(`#accordion_${target}`).addClass('is-active')
                }

                //Refresh all fading effects after toggle
                ScrollTrigger.refresh()
            })

            // Remove .is-active for all tab titles
            $this.$triggerTab.removeClass('is-active')

            //Add .is-active only for the currently related tab title
            $(`#tab_${target}`).addClass('is-active')
        })

        $(window).on('resize orientationchange', () => {
            let windowWidth = $(window).width()

            if ($('.verticals-wrapper').length) {
                let lastTarget = $('.js-vertical-tabs-title.is-active')

                let lastTargetId = lastTarget
                    .attr('id')
                    .substring('tab_'.length)
                if (windowWidth > 1024 && this.isMobile === true) {
                    this.isMobile = false

                    //Remove .is-active for all items but the last one clicked
                    $('.js-vertical-accordion-item').removeClass('is-active')
                    $(`#accordion_${lastTargetId}`).addClass('is-active')
                    //Show content on desktop, even if you collapsed the current accordion on last click while on tablet/mobile
                    $('.js-vertical-accordion-content').show()

                    //Refresh all fading effects
                    ScrollTrigger.refresh()
                }
                if (windowWidth < 1025 && this.isMobile === false) {
                    this.isMobile = true

                    //Show only the last clicked content on mobile/tablet, even if you had more than one accordion opened on previous resize
                    $('.js-vertical-accordion-content').hide()

                    $(`#accordion_${lastTargetId}`)
                        .find('.js-vertical-accordion-content')
                        .show()
                }
            }
        })
    },
}

animateVerticals.init()
